<template>
  <div :class="_box_" :style="{height:height}">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Box',
    display: '',
    data() {
      return {
        preCls: 'mc-box',
      }
    },
    props: {
      shape: {
        type: String,
        default: '',//'circle'圆角, 'rectangle'直角
      },
      size: String,
      height: String,
    },
    computed: {
      _box_() {
          let {preCls, size, shape} = this
          let className = [
            `${preCls}`,
            {
              [`${preCls}-${size}`]: !!size,
              [`${preCls}-${shape}`]: !!shape,
            },
          ]
          return className
      }
    },
    methods: {

    },
  }
</script>



// WEBPACK FOOTER //
// src/components/box/box.vue